import "../style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BsTwitterX } from "react-icons/bs";
import { FaYoutube, FaMediumM } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import moment from "moment";
import { notification } from "antd";
import { useEffect, useState } from "react";
import { Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { registration } from "../../controllers/interest/interestController";
import { investorFirmsList } from "../../controllers/investor/accounts";

const OTHERS_FIRM_VALUE = "__others__";

const InvitationForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { firm_id } = params;

  const [ALLFRIMS, setFirmsListData] = useState([]);
  const [selectedFirmId, setSelectedFirmId] = useState("");
  const [isOtherFirm, setIsOtherFirm] = useState(false);

  const getInvestingFirms = async () => {
    try {
      setFirmsListData([]);
      const options = {
        type: "",
        condition: {},
        select: {},
        sort: { investor_firm_name: 1 },
        skip: 0,
        limit: 0,
      }
      const res = await investorFirmsList(options);
      if (res.status === true) {
        setFirmsListData(res.result);
      }
    } catch (error) {
      setFirmsListData([]);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const formData = new FormData(e.target);

      // Determine whether we're in "Others" firm mode (only relevant when
      // there's no firm_id route param, i.e. the select is actually shown)
      const isOthersSelected = !firm_id && selectedFirmId === OTHERS_FIRM_VALUE;
      const finalFirmId = firm_id || (isOthersSelected ? "" : selectedFirmId);
      const enteredFirmName = isOthersSelected
        ? (formData.get('investor_other_firm_name') || "").trim()
        : "";

      const option = {
        // firm_id and firm_name are added conditionally below so they are
        // never both present in the payload
        ...(finalFirmId ? { firm_id: finalFirmId } : {}),
        ...(isOthersSelected && enteredFirmName ? { firm_name: enteredFirmName } : {}),
        investor_first_name: formData.get('investor_first_name'),
        ...(formData.get('investor_last_name') && { investor_last_name: formData.get('investor_last_name') }),
        investor_designation: formData.get('investor_designation'),
        investor_email: formData.get('investor_email').trim(),
        ...(formData.get('investor_phone') && { investor_phone: formData.get('investor_phone').trim() })
      }
      console.log('option',option);
      if (!finalFirmId && !isOthersSelected) {
        notification.open({
          message: "Oops!",
          description: `Please select a firm.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        return;
      } else if (isOthersSelected && !enteredFirmName) {
        notification.open({
          message: "Oops!",
          description: `Please enter the firm name.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        return;
      } else if (!option?.investor_first_name) {
        notification.open({
          message: "Oops!",
          description: `First name is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        return;
      }
      else if (!option?.investor_designation) {
        notification.open({
          message: "Oops!",
          description: `Designation is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        return;
      }
      else if (!option?.investor_email) {
        notification.open({
          message: "Oops!",
          description: `Email address is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        return;
      } else {
        console.log('option after val',option);
        // return;
        const res = await registration(option);
        // console.log('after return');
        if (res?.status === true) {
          notification.open({
            message: "Success",
            description: `Your account is created successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate('/');
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message || 'Try again.'}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Something went wrong.}`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

  useEffect(() => {
    document.title = "Chiratae Ventures | Spotlight ";
    if (!firm_id) {
      getInvestingFirms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DESIGNATIONS = [
    "Analyst",
    "Senior Analyst",
    "Associate",
    "Senior Associate",
    "AVP",
    "VP",
    "SVP",
    "Principal",
    "Partner",
    "Director",
    "Managing Director",
    "Founder/CEO",
    "Others"
  ];
  const [isOtherDesignation, setIsOtherDesignation] = useState(false);
  const [ designationValue, setDesignationValue] = useState("");


  return (
    <>
      <div className="landing">
        <div className="header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5 col-12 main_logo">
                <Link to="/">
                  <img src={`/image/logo.png`} alt="logo" className="logo" />
                </Link>
                <div className="inner_section invitation_section">
                  <h1>Chiratae Ventures</h1>
                  <h2>
                    India's Largest Home Grown <br></br>Venture Capital Fund.
                  </h2>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="investor_form">
                        <h6 style={{textAlign:"center"}}>Registration Form</h6>

                        {!firm_id && (
                          <div>
                            <Select
                              showSearch
                              placeholder="Select Firm *"
                              className="invitation_select"
                              style={{ width: "100%" }}
                              value={selectedFirmId || undefined}
                              onChange={(value) => {
                                setSelectedFirmId(value);
                                setIsOtherFirm(value === OTHERS_FIRM_VALUE);
                              }}
                              optionFilterProp="label"
                              filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                              }
                              options={[
                                ...(Array.isArray(ALLFRIMS)
                                  ? ALLFRIMS.map((firm) => ({
                                      value: firm._id,
                                      label: firm.investor_firm_name,
                                    }))
                                  : []),
                                { value: OTHERS_FIRM_VALUE, label: "Others" },
                              ]}
                            />
                          </div>
                        )}

                        {!firm_id && isOtherFirm && (
                          <div>
                            <input
                              type="text"
                              name="investor_other_firm_name"
                              id="investor_other_firm_name"
                              placeholder="Enter Firm Name *"
                            />
                          </div>
                        )}

                        <div>
                          <input name="investor_first_name" id="investor_first_name" placeholder="Enter First Name *" />
                        </div>
                        <div>
                          <input name="investor_last_name" id="investor_last_name" placeholder="Enter Last Name" />
                        </div>
                        <div>
                          <select
                            name={isOtherDesignation ? undefined : "investor_designation"}
                            id="investor_designation"
                            className={designationValue !== "" ? "has-value" : ""}
                            value={isOtherDesignation ? "Others" : undefined}
                            onChange={(e) => {
                              const value = e.target.value;
                              setIsOtherDesignation(value === "Others");
                              setDesignationValue(value);
                            }}
                          >
                            <option value="">Select Designation *</option>
                            {DESIGNATIONS.map((designation) => (
                              <option key={designation} value={designation}>
                                {designation}
                              </option>
                            ))}
                          </select>
                        </div>
                        {isOtherDesignation && (
                          <div>
                            <input
                              type="text"
                              name="investor_designation"
                              id="investor_other_designation"
                              placeholder="Enter Designation *"
                            />
                          </div>
                        )}
                        <div>
                          <input name="investor_phone" id="investor_phone" placeholder="Enter Mobile Number" />
                        </div>
                        <div>
                          <input name="investor_email" id="investor_email" placeholder="Enter Email Id *" />
                        </div>
                        <div className="dashbaord_btn mt-4">
                          <button type="submit">Submit</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-7 px-0 text-align col-12">
                  <img src={`/image/right_img.png`} alt="logo" className="invivation_img" />
              </div>
            </div>
            <div className="row copy_right">
              <div className="col-md-6 col-12">
                <p className="copy_text">
                  Copyright © {moment().format("YYYY")} ® Chiratae Ventures |{" "}
                  <Link
                    to="https://www.chiratae.com/terms-and-conditions/"
                    target="__blank"
                    className="copy_text"
                  >
                    Terms and Conditions Privacy Policy
                  </Link>
                </p>
              </div>
              <div className="col-md-6 col-12">
                <ul className="right_side">
                  <li>
                    <Link to="https://twitter.com/ChirataeVC" target="__blank">
                      {" "}
                      <BsTwitterX className="icon" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.linkedin.com/company/chiratae-ventures/"
                      target="__blank"
                    >
                      {" "}
                      <FaLinkedinIn className="icon" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.youtube.com/channel/UCS5VqCTe-NjUG2fEyov5k6g"
                      target="__blank"
                    >
                      {" "}
                      <FaYoutube className="icon" />{" "}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://medium.com/chiratae-ventures/"
                      target="__blank"
                    >
                      {" "}
                      <FaMediumM className="icon" />{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvitationForm;